import React, { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { BASE_URL_DEV } from "../utils/config";


export const useTokenCheck = () => {
  const fetchTokenCheck = async (): Promise<any> => {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("No token found in localStorage");
    }

    const baseUrl = `${BASE_URL_DEV}`;
    const response = await fetch(`${baseUrl}/check-token`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: Token validation failed`);
    }

    return response.json();
  };

  return useQuery({
    queryKey: ["auth-token-check"],
    queryFn: fetchTokenCheck,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
};
